import { render, staticRenderFns } from "./EuFlag.vue?vue&type=template&id=031daf6a&scoped=true&"
import script from "./EuFlag.vue?vue&type=script&lang=js&"
export * from "./EuFlag.vue?vue&type=script&lang=js&"
import style0 from "./EuFlag.vue?vue&type=style&index=0&id=031daf6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031daf6a",
  null
  
)

export default component.exports